(() => {
  const initializeSupportTabs = (tabs) => {
    const buttons = Array.from(tabs.querySelectorAll('[data-support-tab]'));
    const panels = Array.from(tabs.querySelectorAll('[data-support-panel]'));

    if (!buttons.length || !panels.length) return;

    const resetProductDetails = () => {
      tabs.querySelectorAll('.support-tabs__product-grid.is-detail-view').forEach((grid) => {
        grid.classList.remove('is-detail-view');
        grid.querySelectorAll('[data-product-card]').forEach((card) => {
          card.hidden = false;
          card.setAttribute('aria-expanded', 'false');
          const details = card.querySelector('[data-product-details]');
          if (details) details.hidden = true;
        });
      });
    };

    const activate = (value, moveFocus = false) => {
      resetProductDetails();
      buttons.forEach((button) => {
        const active = button.dataset.supportTab === value;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
        button.tabIndex = active ? 0 : -1;
        if (active && moveFocus) button.focus();
      });

      panels.forEach((panel) => {
        panel.hidden = panel.dataset.supportPanel !== value;
      });
    };
    tabs._supportActivate = activate;

    buttons.forEach((button, index) => {
      button.addEventListener('click', () => activate(button.dataset.supportTab));
      button.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        const nextIndex =
          event.key === 'ArrowRight'
            ? (index + 1) % buttons.length
            : (index - 1 + buttons.length) % buttons.length;
        activate(buttons[nextIndex].dataset.supportTab, true);
      });
    });

    tabs.querySelectorAll('[data-support-category-tabs]').forEach((categoryGroup) => {
      const groupName = categoryGroup.dataset.supportCategoryTabs;
      const categoryButtons = Array.from(categoryGroup.querySelectorAll('[data-support-category-tab]'));
      const categoryPanels = Array.from(tabs.querySelectorAll('[data-support-category-panel]')).filter(
        (panel) => panel.dataset.supportCategoryGroup === groupName
      );

      const activateCategory = (value, moveFocus = false) => {
        if (groupName === 'product') resetProductDetails();
        categoryButtons.forEach((button) => {
          const active = button.dataset.supportCategoryTab === value;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-selected', active ? 'true' : 'false');
          button.tabIndex = active ? 0 : -1;
          if (active && moveFocus) button.focus();
        });

        categoryPanels.forEach((panel) => {
          panel.hidden = panel.dataset.supportCategoryPanel !== value;
        });
      };
      if (!tabs._supportActivateCategory) tabs._supportActivateCategory = {};
      tabs._supportActivateCategory[groupName] = activateCategory;

      categoryButtons.forEach((button, index) => {
        button.addEventListener('click', () => activateCategory(button.dataset.supportCategoryTab));

        button.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
          event.preventDefault();
          const nextIndex =
            event.key === 'ArrowRight'
              ? (index + 1) % categoryButtons.length
              : (index - 1 + categoryButtons.length) % categoryButtons.length;
          activateCategory(categoryButtons[nextIndex].dataset.supportCategoryTab, true);
        });
      });
    });

    tabs.querySelectorAll('[data-faq-list]').forEach((faqList) => {
      const faqItems = Array.from(faqList.querySelectorAll('[data-faq-index]'));
      let toggle = faqList.parentElement.querySelector('[data-faq-toggle]');
      if (faqItems.length <= 5) {
        if (toggle) toggle.hidden = true;
        faqList._supportReveal = (item) => {
          item.hidden = false;
        };
        return;
      }

      if (!toggle) {
        toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'support-tabs__faq-toggle';
        toggle.dataset.faqToggle = '';
        toggle.textContent = 'Show more';
        toggle.setAttribute('aria-expanded', 'false');
        faqList.parentElement.append(toggle);
      }

      const extraItems = faqItems.slice(5);
      let expanded = false;

      const updateFaqVisibility = () => {
        extraItems.forEach((item) => {
          item.hidden = !expanded;
        });
        toggle.textContent = expanded ? 'Show less' : 'Show more';
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      };

      updateFaqVisibility();
      faqList._supportReveal = (item) => {
        if (extraItems.includes(item) && !expanded) {
          expanded = true;
          updateFaqVisibility();
        }
        item.hidden = false;
      };
      toggle.addEventListener('click', () => {
        expanded = !expanded;
        updateFaqVisibility();
      });
    });

    tabs.querySelectorAll('[data-product-card]').forEach((card) => {
      const details = card.querySelector('[data-product-details]');
      if (!details) return;
      const productGrid = card.closest('.support-tabs__product-grid');
      const openDetails = () => {
        productGrid.classList.add('is-detail-view');
        productGrid.querySelectorAll('[data-product-card]').forEach((item) => {
          item.hidden = item !== card;
          item.setAttribute('aria-expanded', item === card ? 'true' : 'false');
        });
        details.hidden = false;
        card.focus();
      };
      const closeDetails = () => {
        productGrid.classList.remove('is-detail-view');
        productGrid.querySelectorAll('[data-product-card]').forEach((item) => {
          item.hidden = false;
          item.setAttribute('aria-expanded', 'false');
        });
        details.hidden = true;
      };
      card._supportOpenDetails = openDetails;
      card.addEventListener('click', (event) => {
        if (event.target.closest('a, button, details, summary, video')) return;
        openDetails();
      });
      card.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        openDetails();
      });
      const openButton = card.querySelector('[data-product-open]');
      if (openButton) {
        openButton.addEventListener('click', (event) => {
          event.stopPropagation();
          openDetails();
        });
      }
      const backButton = details.querySelector('[data-product-back]');
      if (backButton) {
        backButton.addEventListener('click', (event) => {
          event.stopPropagation();
          closeDetails();
        });
      }
    });

    tabs.querySelectorAll('[data-video-open]').forEach((openButton) => {
      const modal = document.getElementById(openButton.getAttribute('aria-controls'));
      if (!modal) return;
      const player = modal.querySelector('[data-video-player]');
      const closeButton = modal.querySelector('[data-video-close]');

      const openModal = () => {
        modal.hidden = false;
        document.body.classList.add('support-video-modal-open');
        closeButton?.focus();
        player?.play().catch(() => {});
      };

      const closeModal = () => {
        player?.pause();
        modal.hidden = true;
        document.body.classList.remove('support-video-modal-open');
        openButton.focus();
      };

      openButton.addEventListener('click', (event) => {
        event.stopPropagation();
        openModal();
      });
      closeButton?.addEventListener('click', closeModal);
      modal.addEventListener('click', (event) => {
        if (event.target === modal) closeModal();
      });
      modal.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closeModal();
      });
    });

  };

  const initialize = () => {
    document.querySelectorAll('[data-support-tabs]').forEach(initializeSupportTabs);

    const searchInput = document.querySelector('[data-support-search-input]');
    const results = document.querySelector('[data-support-search-results]');
    const status = document.querySelector('[data-support-search-status]');
    const supportTabs = Array.from(document.querySelectorAll('[data-support-tabs]'));
    if (!searchInput || !results || !supportTabs.length) return;
    searchInput.form?.addEventListener('submit', (event) => event.preventDefault());

    const normalize = (value) => value
      .toLowerCase()
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

    const editDistance = (left, right) => {
      const previous = Array.from({ length: right.length + 1 }, (_, index) => index);
      for (let leftIndex = 1; leftIndex <= left.length; leftIndex += 1) {
        const current = [leftIndex];
        for (let rightIndex = 1; rightIndex <= right.length; rightIndex += 1) {
          current[rightIndex] = Math.min(
            current[rightIndex - 1] + 1,
            previous[rightIndex] + 1,
            previous[rightIndex - 1] + (left[leftIndex - 1] === right[rightIndex - 1] ? 0 : 1)
          );
        }
        previous.splice(0, previous.length, ...current);
      }
      return previous[right.length];
    };

    const tokenMatches = (token, words) => words.some((word) => {
      if (word.includes(token) || (word.length >= 3 && token.includes(word))) return true;
      const tolerance = token.length >= 8 ? 2 : token.length >= 4 ? 1 : 0;
      if (!tolerance || Math.abs(word.length - token.length) > tolerance) return false;
      return editDistance(token, word) <= tolerance;
    });

    const searchIndex = supportTabs.flatMap((tabs) => Array.from(tabs.querySelectorAll('[data-faq-index]')).map((item) => {
      const productCard = item.closest('[data-product-card]');
      const panel = item.closest('[data-support-category-panel]');
      const question = item.querySelector('[data-faq-question]')?.textContent.trim() || item.textContent.trim();
      const answer = item.querySelector('.support-tabs__faq-answer')?.textContent.trim() || '';
      const context = productCard?.querySelector('.support-tabs__product-name')?.textContent.trim() ||
        panel?.querySelector('.support-tabs__category-title')?.textContent.trim() || 'FAQ';
      const area = productCard ? 'Product Support' : 'General FAQs';
      const questionNormalized = normalize(question);
      const contextNormalized = normalize(`${area} ${context}`);
      return {
        item,
        tabs,
        productCard,
        panel,
        question,
        context,
        area,
        questionNormalized,
        contextNormalized,
        searchable: normalize(`${question} ${answer} ${area} ${context}`)
      };
    }));

    const scoreMatch = (match, query) => {
      const terms = query.split(' ').filter(Boolean);
      const words = match.searchable.split(' ');
      if (!terms.every((term) => tokenMatches(term, words))) return -1;

      let score = 0;
      if (match.questionNormalized.includes(query)) score += 120;
      else if (match.searchable.includes(query)) score += 70;
      terms.forEach((term) => {
        if (match.questionNormalized.includes(term)) score += 28;
        else if (match.contextNormalized.includes(term)) score += 18;
        else score += 8;
      });
      return score;
    };

    const getMatches = (query) => {
      const needle = normalize(query);
      if (!needle) return [];
      return searchIndex
        .map((match) => ({ ...match, score: scoreMatch(match, needle) }))
        .filter((match) => match.score >= 0)
        .sort((left, right) => right.score - left.score || left.question.localeCompare(right.question));
    };

    let resultButtons = [];
    const closeResults = () => {
      results.hidden = true;
      searchInput.setAttribute('aria-expanded', 'false');
      resultButtons = [];
    };

    const navigateToMatch = (match) => {
      const group = match.panel?.dataset.supportCategoryGroup;
      const category = match.panel?.dataset.supportCategoryPanel;
      match.tabs._supportActivate?.(match.productCard ? 'product' : 'faq');
      if (group && category) match.tabs._supportActivateCategory?.[group]?.(category);
      match.productCard?._supportOpenDetails?.();
      match.tabs.querySelectorAll('details[data-faq-index]').forEach((faq) => {
        faq.open = false;
      });
      match.item.closest('[data-faq-list]')?._supportReveal?.(match.item);
      match.item.hidden = false;
      match.item.open = true;
      closeResults();
      searchInput.blur();
      requestAnimationFrame(() => requestAnimationFrame(() => {
        match.item.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }));
    };

    const renderResults = (matches) => {
      results.replaceChildren();
      if (!matches.length) {
        const empty = document.createElement('div');
        empty.className = 'support-search-empty';
        empty.textContent = 'No matching FAQs found.';
        results.append(empty);
      } else {
        matches.slice(0, 8).forEach((match) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'support-search-result';
          button.setAttribute('role', 'option');
          button.setAttribute('aria-selected', 'false');
          const question = document.createElement('strong');
          question.textContent = match.question;
          const context = document.createElement('span');
          context.textContent = `${match.area} · ${match.context}`;
          button.append(question, context);
          button.addEventListener('click', () => navigateToMatch(match));
          results.append(button);
        });
      }
      resultButtons = Array.from(results.querySelectorAll('button'));
      resultButtons.forEach((button, index) => {
        button.addEventListener('focus', () => {
          resultButtons.forEach((item, itemIndex) => item.setAttribute('aria-selected', itemIndex === index ? 'true' : 'false'));
        });
        button.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowDown') {
            event.preventDefault();
            resultButtons[(index + 1) % resultButtons.length]?.focus();
          } else if (event.key === 'ArrowUp') {
            event.preventDefault();
            if (index === 0) searchInput.focus();
            else resultButtons[index - 1]?.focus();
          } else if (event.key === 'Escape') {
            closeResults();
            searchInput.focus();
          }
        });
      });
      results.hidden = false;
      searchInput.setAttribute('aria-expanded', 'true');
      if (status) status.textContent = matches.length ? `${matches.length} matching FAQs found.` : 'No matching FAQs found.';
    };

    const updateResults = () => {
      if (!normalize(searchInput.value)) {
        results.replaceChildren();
        closeResults();
        if (status) status.textContent = '';
        return;
      }
      renderResults(getMatches(searchInput.value));
    };

    let isComposing = false;
    searchInput.addEventListener('compositionstart', () => {
      isComposing = true;
    });
    searchInput.addEventListener('compositionend', () => {
      isComposing = false;
      updateResults();
    });
    searchInput.addEventListener('input', () => {
      if (!isComposing) updateResults();
    });
    searchInput.addEventListener('focus', () => {
      if (normalize(searchInput.value)) renderResults(getMatches(searchInput.value));
    });
    searchInput.addEventListener('keydown', (event) => {
      if (isComposing || event.isComposing || event.keyCode === 229 || event.key === 'Process') return;
      if (event.key === 'ArrowDown' && resultButtons.length) {
        event.preventDefault();
        resultButtons[0].focus();
      } else if (event.key === 'Enter' && resultButtons.length) {
        event.preventDefault();
        resultButtons[0].click();
      } else if (event.key === 'Escape') {
        closeResults();
      }
    });
    document.addEventListener('click', (event) => {
      if (!event.target.closest('[data-support-search]')) closeResults();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();
